import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.li`
  flex: 0 0 calc(33.3% - 8px);
  width: calc(33.3% - 8px);
  margin: 0 10px 40px 0;

  ${mobile(css`
    flex: 1 0 100%;
    width: 100%;
    margin: 0 0 16px 0;
  `)}

  &:nth-child(3n) {
    margin: 0 0 40px 0;

    ${mobile(css`
      margin: 0 0 16px 0;
    `)}
  }

  &:last-child {
    ${mobile(css`
      margin: 0;
    `)}
  }

  .video-thumbnail {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    background-color: ${COLOR.grayScale_800};
    color: ${COLOR.white};
    text-align: center;
    height: 146px;

    ${mobile(css`
      padding: 24px 0;
    `)}

    & * {
      display: block;
      word-break: keep-all;
    }

    em {
      ${setFontStyle("SubHead4")};
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      max-height: 54px;
    }

    strong {
      ${setFontStyle("SubHead3")};
      margin-top: 8px;
    }
  }

  .video-item-info {
    padding: 8px;
    color: ${COLOR.grayScale_600};

    & * {
      word-break: keep-all;
    }

    h4 {
      ${setFontStyle("Caption")};
    }

    h5 {
      ${setFontStyle("Body8")};
      margin-top: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      height: 54px;

      ${mobile(css`
        height: auto;
        max-height: 54px;
      `)}
    }

    .text-button {
      margin-top: 8px;
    }
  }
`;

export default {
  container,
};
